import React, { useState, useEffect } from 'react';
import GlassInfoModel from './GlassInfoModel.jsx';
import GlassInfoSize from './GlassInfoSize.jsx';

export default function GlassInfo({ type, setInfoSelected, sizeInfo, setSizeInfo, disabled }) {
	return (
		<div className={`step-container step-container--extraWide ${disabled ? "disabled" : ""}`}>
			<h3 className="step-header step-header--tall">Step 2: Glassware Information</h3>
			<div className="step-content no-pad-bottom">
				<div className="step-options step-options--moveUp">
					<div className="step-option">
						<i className={`fas fa-ruler-combined selected`} ></i>
						Search by Size
					</div>
				</div>
			</div>
		
			<GlassInfoSize type={type}
				setInfoSelected={setInfoSelected}
				sizeInfo={sizeInfo}
				setSizeInfo={setSizeInfo} />
		

		</div>
	)
}
